import NodeRSA from "node-rsa";

import PublicKey from "src/@common/auth/rsa/PublicKey";

export function generateRSAKey() {
  const key = new NodeRSA(PublicKey, "pkcs8-public");
  return key;
}
